<template>
    <div>导出配置</div>
</template>

<script>
  export default {
    name: 'Config'
  }
</script>

<style scoped>

</style>